import React, { useState, useEffect, useRef } from 'react'
import TextField from '@mui/material/TextField'
import { Tooltip } from '@mui/material'

const CustomInput = (props) => {
    const shrink = props.shrink ? props.shrink.toString() : 'false'
    const inputRef = useRef(null)

    const [inputValue, setInputValue] = useState('')

    const handleKeyPress = (event) => {
        if (
            props.type === 'number' &&
            ['e', 'E', '+', '-'].includes(event.key)
        ) {
            event.preventDefault()
        } else if (event.key === 'Enter') {
            props.formik.setFieldValue(props.name, inputValue)
            if (props.formik) {
                props.formik.submitForm()
            }
        }
    }

    const handlePaste = (event) => {
        const array = ['e', 'E', '+', '-']
        let prevent = false
        let charToFind = event.clipboardData.getData('text')
        if (charToFind) {
            Array.from(charToFind).forEach((char) => {
                if (array.includes(char)) {
                    prevent = true
                }
            })
        }
        if (props.type === 'number' && prevent) {
            event.preventDefault()
        }
    }
    const capitalizeFirstLetter = (str) => {
        return str ? str.replace(/\b\w/g, (match) => match.toUpperCase()) : ''
    }

    const capitalizeAllLetter = (str) => {
        return str ? str.toUpperCase() : ''
    }

    const handleChange = (event) => {
        if (props.propercase) {
            setInputValue(capitalizeFirstLetter(event.target.value))
        } else if (props.capitalize) {
            setInputValue(capitalizeAllLetter(event.target.value))
        } else {
            setInputValue(event.target.value)
        }
    }

    useEffect(() => {
        if (props.propercase) {
            setInputValue(capitalizeFirstLetter(props.value))
        } else if (props.capitalize) {
            setInputValue(capitalizeAllLetter(props.value))
        } else {
            setInputValue(props.value)
        }
    }, [props.value])

    useEffect(() => {
        console.log('onWheel', props.name, props.onWheel)
        if (props.onWheel) {
            const handleWheel = (e) => e.preventDefault()
            inputRef.current.addEventListener('wheel', handleWheel)
        }
    }, [props.onWheel])

    useEffect(() => {
        if (props.forcedAutoFocus) {
            inputRef.current.focus()
        }
    }, [props.forcedAutoFocusUpdateDependency])

    return (
        <div
            className={`customInput ${props.error ? 'error-input' : ''}`}
            style={props.inputStyle ? props.inputStyle : null}
        >
            <Tooltip
                title={props.tooltiptitle}
                arrow={props.tooltiptitle ? true : false}
                placement="top"
                disableHoverListener={true}
                disableFocusListener={props.tooltiptitle ? false : true}
            >
                <TextField
                    value={inputValue}
                    autoFocus={props.autoFocus}
                    name={props.name}
                    onChange={handleChange}
                    onKeyDown={handleKeyPress}
                    onPaste={handlePaste}
                    onBlur={props.onChange}
                    InputProps={{
                        inputProps: props.inputProps,
                        startAdornment: props.startAdornment,
                        endAdornment: props.endAdornment,
                        readOnly: props.readonly,
                        shrink: shrink,
                        'aria-label': props.label,
                    }}
                    InputLabelProps={{
                        id: props.id,
                        name: props.label,
                        'aria-label': props.label,
                        'aria-labelledby': props.id,
                    }}
                    htmlFor={props.id}
                    id={props.id}
                    label={props.label}
                    type={props.type}
                    size={props.size}
                    disabled={props.disabled}
                    variant={props.variant ? props.variant : 'outlined'}
                    placeholder={props.placeholder}
                    error={props.error}
                    helperText={props.helperText}
                    inputRef={inputRef}
                />
            </Tooltip>
        </div>
    )
}

export default CustomInput
